<template>
    <div>
        <div class="order-userInfo" v-if="product.product_id == 13" >
            <div class="userInfo-wrapper" >
                <div class="userInfo-border" >
                    <h5>基本设置</h5>
                    <el-row class="userInfo-group" >
                        <el-row>
                            <el-col :span="8" class="order-item" >学币数量：<span>{{ product.config.xuebi}}</span>&nbsp;<span style="color: red;" v-if="configUsed">{{configUsed['used_coins']}}</span></el-col>
                            <el-col :span="8" class="order-item" >单个账号学币使用限制：<span>{{ product.config.single_account_xuebi}}</span></el-col>
                            <el-col :span="8" class="order-item" >服务时间：<span>{{new Date(product.start_at).toLocaleDateString()}}-{{new Date(product.end_at).toLocaleDateString()}}</span></el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8" class="order-item" >开通状态：<span v-if="product.is_enable">是</span><span v-else >否</span></el-col>
                            <el-col :span="8" class="order-item" >产品价格：<span>{{product.price}}</span></el-col>
                        </el-row>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CommonService from "~/services/common";
export default {
    props: {
        product: {
            type: Object
        }
    },
    data(){
        return {
            configUsed:false
        }
    },
    created(){
        this.getConfigUsed();
    },
    methods:{
        getConfigUsed(){
            CommonService.getConfigUse({order_id:this.product.order_id,product_code:this.product.product_code}).then(res=>{
                if(!res.code){
                    if(res.data){//以默认组为主
                        let config = res.data.find(item=>{
                            return item['ztcname'] == '默认组';
                        });
                        this.configUsed = config;
                    }
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/order/products/xwt-coin.vue